import * as AC from './actionTypes';

export const getGaragesByBuilding = (buildingId, filters = {}) => ({
  type: AC.GET_BUILDING_GARAGES_REQUEST,
  buildingId,
  filters,
});

export const addGarage = (name, buildingId, entranceIds = []) => ({
  type: AC.ADD_GARAGE_REQUEST,
  payload: {name, buildingId, entranceIds},
});

export const editGarage = (name, buildingId, entranceIds = [], id) => ({
  type: AC.EDIT_GARAGE_REQUEST,
  payload: {name, buildingId, entranceIds, id},
});

export const deleteGarage = (id, buildingId) => ({
  type: AC.DELETE_GARAGE_REQUEST,
  id,
  buildingId,
});

export const getCustomerGarages = customerId => ({
  type: AC.GET_CUSTOMER_GARAGES_REQUEST,
  customerId,
});

// All fields except customerId are optional (report-only data).
export const addCustomerGarage = (
  customerId,
  {garageIds = [], siteCode = '', siteNumber = '', carPlates = ''} = {},
) => ({
  type: AC.ADD_CUSTOMER_GARAGE_REQUEST,
  payload: {customerId, garageIds, siteCode, siteNumber, carPlates},
  customerId,
});

export const editCustomerGarage = (
  id,
  customerId,
  {garageIds = [], siteCode = '', siteNumber = '', carPlates = ''} = {},
) => ({
  type: AC.EDIT_CUSTOMER_GARAGE_REQUEST,
  payload: {id, customerId, garageIds, siteCode, siteNumber, carPlates},
  customerId,
});

export const deleteCustomerGarage = (id, customerId) => ({
  type: AC.DELETE_CUSTOMER_GARAGE_REQUEST,
  id,
  customerId,
});

export const getGarageReport = (filters = {}) => ({
  type: AC.GET_GARAGE_REPORT_REQUEST,
  filters,
});

// Projects/entrances that have garage data (dropdown options for the report).
export const getGarageReportFilters = (buildingId = null) => ({
  type: AC.GET_GARAGE_REPORT_FILTERS_REQUEST,
  buildingId,
});
